import React, { useContext } from "react";
import { IconType } from "react-icons";
import styles from "./styles.module.css";
import { useTranslation } from "react-i18next";
import { AssetLocationTypes } from "../../logic/api";

export const TreeViewContext = React.createContext<Partial<ITreeViewContext>>({});

export interface ITreeViewRecord {
    id: number;
    parentId: number;
    path?: string;
    name: string;
    tmpName?: string;
    active: boolean;
    hasChildren: boolean;
}

export interface ITreeViewLoaderProps {
    parentId: number;
    parentRecord: ITreeViewRecord | null;
    flags?: unknown | null;
    defaultExpanded?: AssetLocationTypes[];
}

export interface ITreeViewNodeDesign {
    icon?: IconType,
    colour?: string,
    attachment?: React.FunctionComponent<ITreeViewAttachment>;

}

export interface ITreeViewAttachment {
    record: ITreeViewRecord,
}

export interface ITreeViewContext {
    state: ITreeViewState;
    setState: (state: ITreeViewState) => void;
    treeViewLoader: React.FunctionComponent<ITreeViewLoaderProps & {
        onDragReorder?: (draggedRecord: ITreeViewRecord, targetRecord: ITreeViewRecord, position: 'above' | 'below') => void,
    }>;
    getNodeDesign: (record: ITreeViewRecord) => ITreeViewNodeDesign;
    onDragReorder?: (draggedRecord: ITreeViewRecord, targetRecord: ITreeViewRecord, position: 'above' | 'below') => void;
    enableDragAndDrop?: boolean;
}

export interface ITreeViewState {
    command?: ITreeViewCommand | null;
    treeRootId: number;
    selectedRecord?: ITreeViewRecord | null;
    flags?: Record<string, unknown> | null;
    defaultExpanded?: AssetLocationTypes[];
}

export enum TreeViewCommand {
    add,
    remove,
    update,
    reload,
    reloadAll,
    moveUp,
    moveDown,
    expanded,
    collapsed
}


export interface ITreeViewCommand {
    command: TreeViewCommand;
    targetId?: number | null;
    payLoad?: ITreeViewRecord | null;
}

const TreeView = () => {
    const tvc = useContext(TreeViewContext);
    const { t } = useTranslation();

    if (!tvc.state) {
        return <div>{t("treeView.treeViewStateMissing")}</div>
    }
    if (!tvc.treeViewLoader) {
        return <div>{t("treeView.treeViewLoaderMissing")}</div>
    }
    return <div className={styles.tree}>
        <tvc.treeViewLoader
            flags={tvc.state.flags}
            parentId={tvc.state.treeRootId}
            parentRecord={null}
            defaultExpanded={tvc.state.defaultExpanded}
            onDragReorder={tvc.onDragReorder}
        />
    </div>
};

export default TreeView;